import { parseDateKey } from "../../utils/date";

export const MY_PROFILE_KEY = "me:myProfile";

export const EMPTY_MESSAGE = "No records yet. Contact HR to update.";

export const getFullName = (profile) =>
  profile
    ? [
        profile.firstName,
        profile.middleName,
        profile.lastName,
        profile.extension,
      ]
        .filter(Boolean)
        .join(" ")
    : "";

export const getInitials = (profile) =>
  [profile?.firstName, profile?.lastName]
    .filter(Boolean)
    .map((name) => name[0])
    .join("")
    .toUpperCase() || "?";

// employeeStatus values from the API (Title case; compared case-insensitively).
const STATUS_TONES = {
  active: "green",
  probation: "amber",
  "notice period": "amber",
  resigned: "gray",
  terminated: "gray",
  deceased: "gray",
  awol: "gray",
  incomplete: "blue",
  validated: "blue",
};

export const getStatusTone = (status = "") =>
  STATUS_TONES[status.toLowerCase()] ?? "blue";

// Hides all but the last 4 letters/digits, keeping separators:
// "123-456-789-000" -> "•••-•••-••9-000"
export const maskIdNumber = (value) => {
  if (!value) return "—";
  const text = String(value);
  let toKeep = 4;
  const chars = [...text];
  for (let i = chars.length - 1; i >= 0; i -= 1) {
    if (/[a-z0-9]/i.test(chars[i])) {
      if (toKeep > 0) toKeep -= 1;
      else chars[i] = "•";
    }
  }
  return chars.join("");
};

// A file_url starting with http is a link; anything else is an id in the
// document system that the portal can't open.
export const isLinkUrl = (url) =>
  typeof url === "string" && /^https?:\/\//i.test(url);

// "2012-06-01" -> "Jun 2012"
export const formatMonthYear = (dateKey) =>
  parseDateKey(dateKey)?.toLocaleDateString("en-PH", {
    month: "short",
    year: "numeric",
  }) ?? "";

export const formatYearRange = (from, to) => {
  if (!from && !to) return "";
  if (from && to) return from === to ? String(from) : `${from} – ${to}`;
  return from ? `${from} – present` : String(to);
};

// Newest first; missing values sort last.
export const sortNewestFirst = (items, getKey) =>
  [...items].sort((a, b) =>
    String(getKey(b) ?? "").localeCompare(String(getKey(a) ?? "")),
  );
